import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';

import { PageWrapper, Loader, Alert } from '../../components';
import Actions, { thunks } from '../../redux/modules/orders';
import { ORDER_STATUS } from '../../constants';
import { formatCategory } from '../../utils/format';

class OrderDetails extends React.Component {
    state = {
        status: ''
    }

    componentDidMount() {
        const { match: { params : { id } }, dispatch } = this.props;
        dispatch(thunks.getOrderDetails(id));
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props.data, prevProps.data)) {
            this.setState({ status: this.props.data.status });
        }
    }

    onStatusChange = e => {
        this.setState({ status: e.target.value });
    }

    onSave = () => {
        const { match: { params : { id } }, dispatch } = this.props;
        const {  } = this.props;
        dispatch(thunks.updateStatus({
            status: this.state.status,
            orderId: id,
        }, true));
    }

    render() {
        const { status } = this.state;

        const { 
            data,
            loading,
            error,
            updateProperty,
        } = this.props;
        return (
            <PageWrapper title="Order Details">
                <Loader show={loading}/>
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Order Details"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row mb-2">
                                        <div className="col-md-12 d-flex align-items-center mb-2">
                                            <h4 className="mr-2">Order Details</h4>
                                            {data.status ? ( <span 
                                                className={classNames('badge text-capitalize', {
                                                    'badge-success': data.status !== `rejected` || data.staus !== 'failed_payment',
                                                    'badge-danger' : data.status === 'rejected' || data.status ===`failed_payment`,
                                                })}>{formatCategory(data.status)}</span>) : ''}
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Update Status</label>
                                                <select 
                                                    className="form-control"
                                                    value={status}
                                                    onChange={this.onStatusChange}
                                                >
                                                    <option value="" disabled>Select</option>
                                                    {ORDER_STATUS.map(status => <option key={status.value} value={status.value}>{status.name}</option>)}
                                                </select>
                                            </div> 
                                        </div>
                                    </div>
                                    <div className="table-responsive">   
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Size</th>
                                                    <th>Units</th>
                                                    <th>Price</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.items && data.items.length && data.items.map(product => (
                                                    <tr key={product.id}>
                                                        <td>{product.name}</td>
                                                        <td>{product.size}</td>
                                                        <td>{product.units}</td>
                                                        <td>{product.price.toFixed(2)}</td>
                                                        <td>{(product.units * product.price || 0).toFixed(2)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6"/>
                                        <div className="col-md-4">
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    Value:
                                                </div>
                                                <div className="flex-1 d-flex justify-content-end">
                                                    {(data.orderValue || 0).toFixed(2)}
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    GST:
                                                </div>
                                                <div className="flex-1 d-flex justify-content-end">
                                                    {data.gst}
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    Delivery Charge:
                                                </div>
                                                <div className="flex-1 d-flex justify-content-end">
                                                    {data.deliveryCharge}
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-1">
                                                    <h4>Total:</h4>
                                                </div>
                                                <div className="flex-1 d-flex justify-content-end">
                                                <h4> {data.orderTotal}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 d-flex justify-content-end mt-3">
                                            <button className="btn btn-primary" onClick={this.onSave} disabled={status === data.status}>Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    orders: {
        loadingData: loading,
        error,
        data,
    },
}) => ({
    loading,
    error,
    data,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails)